import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { firstValueFrom, Subscription } from 'rxjs';
import { CatalogPaginationRequest } from 'src/app/features/shared/models/CatalogPagination/CatalogPaginationRequest';
import { FilterRequest } from 'src/app/features/shared/models/Filter/FilterRequest';
import { NotificationService } from 'src/app/features/notifications/services/Notification.service';
import { SwalNotificationService } from 'src/app/features/shared/services/SwalNotification.service';
import { ControlPanelService } from '../../services/ControlPanel.service';
import { Router } from '@angular/router';
import { DashboardAlarmsRequest } from '../../model/DashboardAlarmsRequest';
import { DashboardAlarmsDTO } from '../../model/DashboardAlarmsDTO';
import { EnumAlarmCategoriesValues } from 'src/app/features/shared/helpers/enums/EnumAlarmCategories';

@Component({
  selector: "alarm-chart",
  templateUrl: "./alarm-chart.component.html",
  styleUrls: ["./alarm-chart.component.css"],
})
export class AlarmChartComponent {

  @Input() dashboardAlarms: DashboardAlarmsRequest[] = [];

  isLoading: boolean = false;
  today = new Date();
  month = this.today.getMonth();
  year = this.today.getFullYear();

  chartColors: any[] = [
    {backgroundColor: 'rgba(75, 192, 192, 0.5)', borderColor: 'rgba(75, 192, 192, 1)'},
    {backgroundColor: 'rgba(153, 102, 255, 0.5)', borderColor: 'rgba(153, 102, 255, 1)'},
    {backgroundColor: 'rgba(255, 159, 64, 0.5)', borderColor: 'rgba(255, 159, 64, 1)'},
    {backgroundColor: 'rgba(255, 99, 132, 0.5)', borderColor: 'rgba(255, 99, 132, 1)'},
    {backgroundColor: 'rgba(54, 162, 235, 0.5)', borderColor: 'rgba(54, 162, 235, 1)'},
    {backgroundColor: 'rgba(255, 206, 86, 0.5)', borderColor: 'rgba(255, 206, 86, 1)'},
    {backgroundColor: 'rgba(201, 203, 207, 0.5)', borderColor: 'rgba(201, 203, 207, 1)'},
  ];
  chartData = {
    labels: [],
    datasets: [],
  };

  chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        mode: 'index',
        callbacks: {
          labelColor: (context: any) => {
            const idx = context.datasetIndex ?? 0;
            const color = this.chartColors[idx] ?? { backgroundColor: 'rgba(0,0,0,0.1)', borderColor: 'rgba(0,0,0,0.1)' };
            return {
              borderColor: color.borderColor,
              backgroundColor: color.backgroundColor
            };
          }
        }
      },
    },
    interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false
    },
    scales: {
      x: {
        stacked: true,
        title: {
          display: true,
          text: 'día del mes'
        }
      },
      y: {
        stacked: true,
        title: {
          display: true,
          text: 'Número de alertas'
        }
      },
    },
  };

  constructor(private router: Router
  ) {}

  ngOnInit() {
    this.isLoading = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
      if (changes['dashboardAlarms'] && this.dashboardAlarms) {
        this.chartData.labels = this.getLabelsActual();
        this.chartData.datasets = this.getDataSets(this.dashboardAlarms);
        this.isLoading = false;
      }else{
        this.isLoading = false;
      }
    }
  
  onChartClick(event: { event?: MouseEvent, active?: any[] }) {
    if (event.active && event.active.length > 0) {
      const chartElement = event.active[0] as any;
      const dataSetIndex = chartElement.datasetIndex;
      //el index de la data va a ser el día del mes
      const dataIndex = chartElement.index;

      const data = this.chartData.datasets[dataSetIndex];
      if (data) {
        const alarmName = data.label;
        const alarmDay= dataIndex + 1;
      console.log(alarmName, alarmDay, data, chartElement);
      }
    }
  }
 
  openAlarmsTable(){
    this.router.navigate(['/alarms'], { queryParams: {  } });
  }

  getLabels(): string[] {
    const year = this.today.getFullYear();
    const days = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30"];
    var labels = [];
    days.forEach(day => {
      const label = day + "/" + (this.month + 1).toString().padStart(2, '0') + "/" + year;
      labels.push(label);
    });
    console.log("labels 1",labels);
    return labels;
  }

  //este están como llegan ahorita
  getLabelsActual(): string[] {
    const year = this.today.getFullYear();
    const days = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30"];
    var labels = [];
    days.forEach(day => {
      const label =  day  + "/" + (this.month + 1).toString().padStart(2, '0') + "/" + year;
      labels.push(label);
    });
    console.log("labels 2",labels);
    return labels;
  }

  getDataSets(alarms: DashboardAlarmsRequest[]){
    //traigo las de este mes y año
    var thisMonthAlarms : DashboardAlarmsRequest[] = [];
    alarms.forEach(alarm => {
      //como viene ahorita en el date tipo usa mm/dd/yyyy hh:mm:ss
      // const alarmMonth = alarm.date.split("/")[0];
      // const alarmYear = alarm.date.split("/")[2].split(" ")[0];

      //si cambia a mexico dd/mm/yyyy hh:mm:ss, seria este
      const alarmMonth = alarm.date.split("/")[1];
      const alarmYear = alarm.date.split("/")[2];

      if(alarmMonth == (this.month + 1).toString().padStart(2, '0') && alarmYear == this.year.toString()){
        thisMonthAlarms.push(alarm);
      }

    });
    console.log("thisMonthAlarms", thisMonthAlarms);
    
    //un map para las fechas de los labels y poder agregarles los días que no tienen datos
    const baseMap = new Map<string, number>();
    this.chartData.labels.forEach(label => {
      baseMap.set(label, 0);
    });

    var alarmData: DashboardAlarmsDTO[] = [];
    thisMonthAlarms.forEach(alarm => {
      const label = alarm.date;
      const existingAlarm = alarmData.find(alarmD => alarmD.categoryName === alarm.categoryName);
      baseMap.set(alarm.date, alarm.quantityPerDay);

      if (existingAlarm) {
        existingAlarm.quantityPerDay.set(label, existingAlarm.quantityPerDay.get(label) + alarm.quantityPerDay);
      } else {
        const copiaMap = new Map(baseMap);
        copiaMap.set(label, alarm.quantityPerDay);
        alarmData.push({
          categoryName: alarm.categoryName,
          quantityPerDay: copiaMap,
          date: alarm.date
        });
      }
    });
    console.log("alarmData", alarmData);

    var datasets = alarmData.map((alarm, index) => ({
          label: EnumAlarmCategoriesValues[alarm.categoryName],
          data: Array.from(alarm.quantityPerDay.values()),
          backgroundColor: this.chartColors[index].backgroundColor,
          borderColor: this.chartColors[index].borderColor,
          fill: true,
        }));

    return datasets;
  }

}
